import React from 'react';
import styled from 'styled-components';

import Select from 'components/Select/SelectFilter';

const NoteFiltersContainer = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    justify-content: space-between;
  }

  .row > * {
    flex-basis: 15%;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    > div {
      padding: 0;
      height: auto;
    }

    .row {
      gap: 16px;
      flex-direction: column;
      align-items: center;
    }

    .row > div {
      width: 100%;
    }
  }
`;

const NoteFilters = ({
  wineFilter,
  vintagesFilter,
  journalFilter,
  tasterFilter,
  typeFilter,
  hasWxrPanel
}) => (
  <NoteFiltersContainer>
    <div className="row">
      <Select {...wineFilter} />
      <Select {...vintagesFilter} />
      <Select {...journalFilter} />
      <Select {...tasterFilter} />
      {hasWxrPanel && <Select {...typeFilter} />}
    </div>
  </NoteFiltersContainer>
);

export default NoteFilters;
